import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { TableCell } from "@mui/material";
const TableHeaderCell = React.memo(({ column }) => (_jsx(TableCell, Object.assign({ align: column.align, style: { minWidth: column.minWidth }, sx: { fontWeight: "bold" } }, { children: column.label }), column.id)));
TableHeaderCell.displayName = "TableHeaderCell";
export default TableHeaderCell;
